<template>
  <div class="changePwd">
    <Card class="card">
      <!-- <div class="topTit">
        <p>基本信息</p>
      </div> -->
      <div class="seccessBox">
        <div class="successImg">
          <img src="@/assets/img/user/reset_pwd.png" alt="" />
        </div>
        <div class="bigTit">恭喜您，密码修改成功</div>
        <div class="jumpTime">{{ time }}秒后将返回登录页面</div>
        <div class="loginBtn">
          <Button class="btn1" type="primary" @click="reLogin">立即登录</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "ChangePwd",
  data() {
    return {
      time: 6,
      timer: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    this.timer = setInterval(() => {
      this.time--;
      if (this.time == 0) {
        clearInterval(this.timer);
        _Cookie.remove('adminauth');
        this.$router.push({ path: "/login" });
      }
    }, 1000);
  },
  methods: {
    link(path) {
      //  this.$Message.success("撤回成功");
      this.$router.push({ path: path });
    },
    reLogin() {
      _Cookie.remove('adminauth');
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss">
.changePwd {
  width: 100%;
  .card {
    width: 100%;
    min-height: calc(100vh - 150px);
    font-size: 14px;
    color: #2f4061;
    // .topTit {
    //   width: 100%;
    //   font-size: 16px;
    //   font-family: MicrosoftYaHeiSemibold;
    //   color: #2f4061;
    //   font-weight: bold;
    //   border-bottom: 1px solid #ebedf0;
    //   box-sizing: border-box;
    //   padding: 10px 0px;
    // }
    .seccessBox {
      width: 50%;
      margin: 0 auto;
      .successImg {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 15px;
      }
      .bigTit {
        display: flex;
        justify-content: center;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #2f4061;
      }
      .jumpTime {
        display: flex;
        justify-content: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #67799c;
        margin-top: 10px;
      }
      .loginBtn {
        display: flex;
        justify-content: center;
        .btn1 {
          border-radius: 20px;
          width: 60%;
          height: 40px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>